import { ID_CONTENU, LienEvitement } from '@/components/layout/lien-evitement';
import { useTitrePage } from '@/lib/titre-page';
import { LoginCard } from './login-card';

interface PageLoginProps {
  /** Called once the visitor is signed in. */
  onConnecte: () => void;
  /** The user was sent here because their session expired (#13): the panel says so. */
  sessionExpiree?: boolean;
}

/** The help line under the panel (#13: one sentence, no false link, the forgotten password in it). */
export const LIGNE_AIDE =
  "Mot de passe oublié ou besoin d'aide ? Contactez votre interlocuteur chez patrickmathieu singularité.";

/**
 * The login page: `gray-50` background, the 432 px panel centred, the help line
 * under it. No navbar and no header: the shell of the root route leaves `/login` bare. It
 * still has the skip link, so that every page of the app starts the same way for the keyboard.
 */
export function PageLogin({ onConnecte, sessionExpiree = false }: PageLoginProps) {
  useTitrePage('Connexion');
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-8 leading-[normal]">
      <LienEvitement />
      <main
        id={ID_CONTENU}
        tabIndex={-1}
        className="flex w-[432px] max-w-full flex-col items-center outline-none"
      >
        <LoginCard onConnecte={onConnecte} sessionExpiree={sessionExpiree} />
        <p className="mt-6 text-center font-light text-caption text-gray-600">{LIGNE_AIDE}</p>
      </main>
    </div>
  );
}
